import * as React from 'react';
import DetailsContainer from '../../components/tables/DetailsContainer';
import DetailsBlock from '../../components/tables/DetailsBlock';
import { localizations } from '../../localization/localization';
import { RegisteredCompanyDataModel } from '../models/CompanyModels';
import { DetailsValueBlock } from '../../components/tables/DetailsValueBlock';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { renderEmailDetails, renderContactPersonDetails, renderAddressDetails, renderPhoneDetails, renderDescriptionDetails, renderIndustryTypeDetails } from '../../components/tables/DetailsHelpers';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => createStyles({
    buttonMargin: {
        marginRight: 10
    }
  });

interface AcceptProps {
    acceptCompany: (companyId: string) => void, 
    rejectCompany: (companyId: string) => void
}

type AppliedCompanyInformationProps = RegisteredCompanyDataModel & AcceptProps;

const AppliedCompanyInformation: React.SFC<WithStyles & AppliedCompanyInformationProps> = ({
    classes,
    acceptCompany, 
    rejectCompany,
    id,
    name,
    address,
    phoneContacts,
    emailContacts,
    contactPerson,
    website,
    description,
    industryType
}) => {

    const handleClick = (companyId: string) => (event: any) => acceptCompany(companyId);   
    const handleRejectClick = (companyId: string) => (event: any) => rejectCompany(companyId);

    return <DetailsContainer>
        <DetailsBlock title={localizations.admin.appliedCompanyInformationHeader} rightItems={
            <Grid container spacing={2}>
                <Grid item>
                    <Button variant="contained" color="primary" onClick={handleRejectClick(id)} className={classes.buttonMargin}>
                        {localizations.actions.reject}
                    </Button>
                    <Button variant="contained" color="secondary" onClick={handleClick(id)}>
                        {localizations.actions.accept}
                    </Button>
                </Grid>
            </Grid>}>
            <DetailsValueBlock title={localizations.common.companyName}>
                <Typography>{name}</Typography>
            </DetailsValueBlock>
            {renderAddressDetails(address)}
            {phoneContacts.map((item, index) => <React.Fragment key={index}>
                {renderPhoneDetails(item)}
            </React.Fragment>)}
            {emailContacts.map((item, index) => <React.Fragment key={index}>
                {renderEmailDetails(item)}
            </React.Fragment>)}
            {renderContactPersonDetails(contactPerson)}
            <DetailsValueBlock title={localizations.common.website}>
                <Typography>{website}</Typography>
            </DetailsValueBlock>
            {renderIndustryTypeDetails(industryType)}
            {renderDescriptionDetails(description)}
        </DetailsBlock>
    </DetailsContainer>
}

export default withStyles(styles)(AppliedCompanyInformation);


// WEBPACK FOOTER //
// ./src/admin/companies/AppliedCompanyInformation.tsx